'use strict';

angular.module('more.ui.form-builder').service('$loadingHelper', function () {
  return {
    addTranslatedMessageContent: function () {},
    addMessage: function () {},
    hideMessage: function () {}
  };
});